import Tippy from '@tippyjs/react/headless';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { Typography } from "../typography/Typography.js";
import styles from "./ShakyMessage.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ShakyMessage(props) {
  const [shake, setShake] = useState(false);
  const [open, setOpen] = useState(false);
  const childRef = useRef(null);
  const classes = classNames(styles.tooltip, props.className);
  function shakeMe() {
    if (props.trigger) {
      setShake(true);
      setOpen(true);
      setTimeout(() => setShake(false), 1000);
    }
  }
  return /*#__PURE__*/_jsx(Tippy, {
    reference: childRef,
    offset: [10, 10],
    placement: "auto",
    visible: open,
    onClickOutside: () => setOpen(false),
    interactive: true,
    zIndex: 1010,
    render: attrs => /*#__PURE__*/_jsxs("div", {
      className: classes,
      tabIndex: -1,
      ...attrs,
      children: [/*#__PURE__*/_jsx("header", {
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          margin: false,
          children: props.title
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.contentContainer,
        children: props.content
      }), /*#__PURE__*/_jsx("div", {
        "data-popper-arrow": "",
        className: styles.arrowContainer
      })]
    }),
    children: /*#__PURE__*/_jsx("span", {
      className: classNames(styles.shakyContainer, shake && styles.shake, props.trigger && styles.triggered),
      ref: childRef,
      onClick: shakeMe,
      children: props.children
    })
  });
}